export const SHOWCASE = {
  name: 'Rebecca Wilson',
  title: 'Chief Curator and VP, Art Advisory',
  blurb: `Rebecca Wilson is Chief Curator and VP, Art Advisory at Saatchi Art. She was formerly a Director at the Saatchi Gallery, London, where she was instrumental in the launch of the gallery's online presence. Rebecca has over 15 years of experience working with emerging artists and helping hospitality, corporate, healthcare and private clients to build art collections.`,
  showCaseImage: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-rebecca-desk.jpg',
  image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-rebecca-headshot-desk.jpg',
}
// {
//   name: 'Jessica Baumann-Houmes',
//   title: 'Sales Representative',
//   featureImgBase: '',
//   image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-jessica-headshot',
//   blurb: 'Territory: Florida',
// },
// The top row should be: Tara, Josh, Connie, Chelsea
// Second row: Samantha, Catherine, Lindsey, Ashley
// Third row: Cristina, Sean, Lindsay, Patricia
export const TEAM = [
  {
    name: 'Tara LaManna',
    title: 'Senior Art Advisor',
    blurb:
      'Pairing a creative eye with a strong understanding of client relations, Tara LaManna has over 12 years of full service art consulting experience for residential,commercial, and hospitality design.',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-tara-headshot-desk.jpg',
  },
  {
    name: 'Josh Gregg',
    title: 'Senior Art Advisor',
    blurb:
      'Drawn by an innate artistic adoration, Josh possesses a uniquely creative background that combines nearly a decade of experience in hospitality design and art consulting with academic knowledge of the arts and design.',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-josh-headshot-desk.jpg',
  },
  {
    name: 'Connie Kim',
    title: 'Hospitality Art Advisor',
    blurb:
      'With extensive experience in contemporary galleries and artist studios, Connie Kim collaborates closely with clients to deliver impactful spaces featuring thoughtfully curated works.',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-connie-headshot-desk.jpg',
  },
  {
    name: 'Chelsea Finical',
    title: 'Senior Project Manager',
    blurb:
      'Coming from a strong background in creative project management and art consulting, Chelsea Finical works in tandem with art advisors, artists and suppliers to ensure seamless quoting, sourcing, and production of hospitality projects.',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-chelsea-headshot-desk.jpg',
  },
  {
    name: 'Samantha Varney',
    title: 'Finance Operations Associate',
    blurb:
      'From day to day tasks and key reporting initiatives, Samantha Varney provides support and ensures financial and accounting operations run smoothly for the Hospitality team.',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-samantha-headshot-desk.jpg',
  },
  {
    name: 'Catherine Bell',
    title: 'Hospitality Project Manager',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-catherine-headshot-desk.jpg',
    blurb:
      'Catherine has an MFA in photography along with years of restaurant experience and project management. She works with art advisors, artists, and suppliers to ensure that projects are delivered seamlessly from quotes to specifications and final installation.',
  },
  {
    name: 'Lindsey Moore',
    title: 'Hospitality Project Manager',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-lindsey-headshot-desk.jpeg',
    blurb:
      'With a variety of professional experiences and education—from crisis management to international purchasing and logistics—Lindsey works with art advisors, artists, and suppliers to ensure quotes and specifications are accurate for production.',
  },
  {
    name: 'Ashley Johnson',
    title: 'Hospitality Project Manager',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-ashley-johnson-headshot-desk.jpg',
    blurb:
      'With over 17 years of hospitality experience, Ashley Johnson has held positions as Director of Operations for a wholesale art manufacturer working with hospitality, healthcare, commercial and residential art framing.',
  },
  {
    name: 'Cristina Antolino',
    title: 'Sales Representative',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-cristina-headshot-desk.jpg',
    blurb: 'New York, Dallas, Houston, Select LA, Select Chicago',
  },
  {
    name: 'Sean Baumann',
    title: 'Sales Representative',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-sean-headshot-desk.jpg',
    blurb: 'Territory: Florida',
  },
  {
    name: 'Lyndsay Brady',
    title: 'Sales Representative',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-lyndsay-headshot-desk.jpg',
    blurb: 'Territory: Hawaii, Southern California',
  },
  {
    name: 'Patricia Gentry',
    title: 'Sales Representative',
    blurb: 'Georgia, Tennessee, Alabama',
    image: '//d3t95n9c6zzriw.cloudfront.net/trade/team/team-patricia-headshot-desk.jpg',
  },
]